export const removeDuplicates = (array,key='id') => {
    const uniqueItems = array?.filter((item, index) => {
      return index === array?.findIndex((data) => item[key] === data[key]);
    });
    return uniqueItems;
  };